var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10C12.016 10 10 12.016 10 14.5C10 16.984 12.016 19 14.5 19C16.984 19 19 16.984 19 14.5C19 12.016 16.984 10 14.5 10ZM17.2 14.95H14.95V17.2H14.05V14.95H11.8V14.05H14.05V11.8H14.95V14.05H17.2V14.95Z",
    fill: "#448870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 2.25038C10.4655 1.91654 9.53452 1.91654 8.7 2.25038L2.943 4.55538C2.66491 4.6666 2.42648 4.85852 2.25842 5.10643C2.09035 5.35434 2.00035 5.64688 2 5.94638V13.5924C1.99995 13.8922 2.08977 14.1852 2.25785 14.4335C2.42594 14.6818 2.66459 14.874 2.943 14.9854L8.7 17.2884C9.13718 17.4634 9.60519 17.5485 10.076 17.5384C9.8326 17.2097 9.62665 16.8548 9.462 16.4804C9.32894 16.4511 9.1985 16.411 9.072 16.3604L3.314 14.0574C3.22115 14.0202 3.1416 13.956 3.08563 13.8731C3.02965 13.7902 2.99982 13.6924 3 13.5924V6.00838L9.5 8.60839V11.9754C9.75062 11.4309 10.0884 10.931 10.5 10.4954V8.60738L17 6.00738V9.36838C17.358 9.55138 17.693 9.77238 18 10.0264V5.94638C18.0001 5.64654 17.9102 5.35356 17.7421 5.10526C17.5741 4.85695 17.3354 4.66473 17.057 4.55338L11.3 2.25038ZM9.072 3.18038C9.66804 2.94196 10.333 2.94196 10.929 3.18038L16.154 5.27038L13.875 6.18038L7.721 3.72038L9.072 3.18038ZM6.375 4.25738L12.529 6.71838L10 7.73138L3.846 5.26938L6.375 4.25738Z",
    fill: "#currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage4);
export default __webpack_public_path__ + "static/media/package-4.fd987b3d50c75ef1fcb2f092b9368344.svg";
export { ForwardRef as ReactComponent };